// extracted by mini-css-extract-plugin
export default {"center":"DetailBoxColumn_center__uttuH"};